
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shops/[uuid]/photos",
      function () {
        return require("private-next-pages/shops/[uuid]/photos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shops/[uuid]/photos"])
      });
    }
  